module.exports = __webpack_public_path__ + "product-pure-powder-capsule-10.jpg?7f8f90173a21a40e6608e2a21ff26f18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-10.jpg
// module id = 92
// module chunks = 0